<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas fa-lg autoCursor" [icon]="faTasks"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">{{ 'menu.sprintPlanner' | translate }}</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
        <p class="titleParagraph">{{'sprintPlanner.toolHeaderLine1' | translate}}<br>
          {{'sprintPlanner.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <div class="dropGroupBtn marginbottom5px">
          <span>
            <a id="taskPlannerYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTP1">
              <fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
            </a>
          </span>
        </div>
        <div class="dropGroupBtn marginbottom5px">
          <span type="button" (click)="sprintName && generateReport('true')">
            <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Section header end -->

  <div class="environ-designer tool-body-height">
    <div class="card p-1 h-100 bg-white">
      <!-- sprint plan section open -->
      <div class="row full-width p-1">
        <div class="col-xs-12">
          <div class="row strict">
            <div class="col col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9">
              <div class="row strict pr-2">
                <!-- sprint plan selection dropdown -->
                <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 dropdown" *ngIf="!showText">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    [ngClass]="{ dis:sprintNamesArray.length<=0}" type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-10 span-on-button ">
                        <span *ngIf="sprintNamesArray.length>0">
                          {{sprintName || 'taskPlanner1.choosePlanHeading' | translate }}
                        </span>
                        <span *ngIf="sprintNamesArray.length<=0">
                          {{sprintName || 'taskPlanner.addPlanHeading' | translate }}
                        </span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu">
                    <li (click)="selectedSprint(false,false,sprint)"
                      [ngClass]="{displayNone:sprintNamesArray.length<=0}"
                      *ngFor="let sprint of sprintNamesArray; let tabIndex = index">
                      <a>{{sprint.sprintName}}</a>
                    </li>
                    <li *ngIf="!(sprintNamesArray.length > 0)" [ngClass]="{ dis:sprintNamesArray.length<=0}">
                      <div class="col-xs-12 alert mb-0 p-0">
                        <strong>{{ 'taskPlanner1.emptyPlannameList' | translate }}</strong>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- sprint plan adding new input field -->

                <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pr-2" *ngIf="showText">
                  <input id="taskPlannerInputField" type="text"
                    (keyup.enter)="sprintNameChanged(sprintName,oldSprintName, updateSprintname)"
                    [placeholder]="'taskPlanner.planNamePlaceholder'| translate" [(ngModel)]='sprintName'
                    class="form-control strict lg-input pl-3 pr-3 taskplanner-inputfield">
                </div>

              </div>
            </div>
            <div class="col col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 paddingleft3px paddingright6px">
              <div class="row strict">
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div>
                    <button type="button" [ngClass]="{ dis:showText==true}" (click)="selectedSprint(true,true,'')"
                      class="btn btn-default btn-block btn-sm tpButton">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>

                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div>
                    <button type="button" class="btn btn-block btn-default btn-sm tpButton"
                      [ngClass]="{ dis:showText==true || new==true}" (click)="editPlanname(sprintName)">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faEdit"></fa-icon>

                    </button>
                  </div>
                </div>

                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div *ngIf="showText">
                    <button type="button" (click)="clear()" class="btn btn-default btn-block btn-sm tpButton">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faTimes"></fa-icon>

                    </button>
                  </div>
                  <div *ngIf="!showText">
                    <button type="button" [ngClass]="{ dis:showText==true || sprintName == ''}"
                      class="btn btn-block btn-default btn-sm tpButton" data-toggle="modal"
                      data-target="#newSPsprintDeleteConfirmModel">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faTrashAlt"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1">
              <button type="button" [ngClass]="{ dis:fieldsDisabled || EUTDDisabled}" title="Add entities to sprint"
                class="btn btn-default btn-sm btn-block paddingtop3px paddingbottom3px pl-1 pr-1" data-toggle="modal"
                data-target="#sprintEntitiesModel">
                <span *ngIf="listOfEUTs.length">
                  {{'taskPlanner1.EUTLink' | translate }}
                </span>
                <span *ngIf="!listOfEUTs.length">
                  {{'taskPlanner1.addEntityButton' | translate }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- sprint plan section close -->
      <!-- sprint plan -- -->

      <div class="row strict task-planner-filter-table-section-height">
        <div class="col-xs-12 pr-2 pl-0">
          <div class="row strict">
            <div class="col-xs-1">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      type="button" data-toggle="dropdown" [ngClass]="{ dis:activityDisabled}">
                      <div class="row strict">
                        <div class="col-xs-10 text-flow">
                          <span>
                            {{selectedActivity||'taskPlanner1.chooseActivity' | translate }}
                          </span>
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu testDesignerEntityDropdown w-200">
                      <li class="row strict" *ngFor="let activity of activityTypes; let tabIndex = index">
                        <div class="col-xs-11 col-xs-offset-1 dropdown-item" (click)="changeActivity(activity)">
                          {{activity.name}}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- Freeform test input field open  -->
            <div class="col-xs-8" [ngClass]="{displayNone:hideFTField}">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding">
                  <input id="taskPlannerFreeformInputField" [ngClass]="{ dis:fieldsDisabled}" type="text"
                    [placeholder]="'taskPlanner1.freeformTextPlaceholder'| translate" [(ngModel)]='freeFormTestData'
                    class="form-control strict lg-input pl-3 pr-3 taskplanner-inputfield">
                </div>
              </div>
            </div>
            <!-- Freeform test input field close -->
            <div class="col-xs-4" [ngClass]="{displayNone:hideEUTDD}">
              <div class="row strict">
                <div class="col-sm-2 col-xs-3 btn-padding">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      type="button" data-toggle="dropdown" [ngClass]="{ dis:fieldsDisabled || EUTTypeDDisabled}">
                      <div class="row strict">
                        <div class="col-xs-10">
                          <span *ngIf="selectedEUT!=''">{{selectedEUT}}
                          </span>
                          <span *ngIf="selectedEUT==''">{{'taskPlanner1.chooseEUT' | translate
                            }}</span>
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu testDesignerEntityDropdown">
                      <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                        <div class="col-xs-11 col-xs-offset-1   dropdown-item" (click)="changeEntity(eut)">
                          {{eut}}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-sm-10 col-xs-9 btn-padding">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      type="button" [ngClass]="{ dis:fieldsDisabled || EUTDDisabled}" data-toggle="dropdown">
                      <div class="row strict" *ngIf="sprintEntityExists(eutTypes[index])">
                        <div class="col-xs-10 span-on-button ">
                          {{entityName||'taskPlanner1.chooseEntityButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                      <div *ngIf="!sprintEntityExists(eutTypes[index]) && selectedEUT!='TT'">
                        <strong>
                          {{ 'no' | translate }} {{getEntityType(eutTypes[index]) | lowercase}} {{'taskPlanner.defined'
                          | translate}}.
                        </strong>
                      </div>
                    </button>
                    <ul class="dropdown-menu fit-size w-200">
                      <li *ngIf="!sprintEntityExists(eutTypes[index])&& selectedEUT!='TT'">
                        <div class="alert alert-warning mb-0 pb-1 pt-1">
                          <strong>
                            {{ 'no' | translate }} {{getEntityType(eutTypes[index]) | lowercase}}
                            {{'taskPlanner.defined' | translate}}.
                          </strong>
                        </div>
                      </li>
                      <div class="row">
                        <div class="col-xs-12">
                          <div class="input-group input-group-sm">
                            <input type="text" class="form-control search-add-on" [(ngModel)]="eutsearchText"
                              [placeholder]="'entities.searchEntity'| translate">
                            <span class="input-group-addon" id="basic-addon2">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faSearch"></fa-icon>
                            </span>
                            <!-- <span class="input-group-addon" id="basic-addon3" (click)="showEntityAddPopup()"
                              data-toggle="modal" data-target="#addNewEntityPopup">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                            </span> -->
                          </div>
                        </div>
                      </div>
                      <li
                        *ngFor="let eut of modelData.sprintEUTs|taskPlannerEUTFilterWithSearchText:{eType:selectedEUT}:filterTypeList:eutsearchText:sprintName; let tabIndex = index"
                        (click)="loadEntityDetails(eut,false)">
                        <a class="dropdown-item">{{eut.eName}}</a>
                        <!-- ({{eut.scenarioCount}}) -->
                      </li>
                    </ul>

                    <!-- <button type="button" [ngClass]="{ dis:fieldsDisabled || EUTDDisabled}"
                      class="btn btn-default btn-sm btn-block paddingtop3px paddingbottom3px" data-toggle="modal"
                      data-target="#taskImpactEntitiesModel">
                      <span *ngIf="listOfEUTs.length">
                        {{'taskPlanner1.chooseEntityButton' | translate }}
                      </span>
                      <span *ngIf="!listOfEUTs.length">
                        {{'taskPlanner1.addEntityButton' | translate }}
                      </span>
                    </button> -->

                  </div>
                </div>
              </div>
            </div>



            <!-- Attribute and environment dropdown open -->
            <div class="col-xs-4" [ngClass]="{displayNone:hideClistDD}">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding ">
                  <div class="dropdown">
                    <button
                      [ngClass]="{ dis:model.checklists.length<=0 && publicChecklists.length<=0 || fieldsDisabled}"
                      class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      type="button" data-toggle="dropdown">
                      <div class="row strict">
                        <div class="col-xs-10 span-on-button ">
                          <span *ngIf="model.checklists.length>0 || publicChecklists.length>0">

                            <fa-icon class="fa menuItemsClrBlack" [icon]="faLock"></fa-icon>

                            <!-- *ngIf="selectedtaskPlanner1.checkType == 'public'" -->
                            <!-- [ngClass]="{displayNone:sprintNamesArray.length<=0}" -->

                            &nbsp;
                            {{selectedChecklist.checklistName|| 'taskPlanner1.chooseChecklist' | translate }}
                          </span>
                          <span *ngIf="model.checklists.length<=0 && publicChecklists.length<=0">{{
                            'taskPlanner1.noChecklist' | translate }}</span>
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu">
                      <li (click)="chooseChecklist(cl)" *ngFor="let cl of model.checklists; let tabIndex = index">
                        <a>{{cl.checklistName}}</a>
                      </li>
                      <hr *ngIf='model.checklists.length>0 && publicChecklists.length>0'
                        class="mt-1 mb-1 border-top-1px-black" />
                      <li (click)="chooseChecklist(cl)" *ngFor="let cl of publicChecklists; let tabIndex = index">
                        <a>
                          <fa-icon class="fa menuItemsClrBlack" [icon]="faLock"></fa-icon>
                          &nbsp;{{cl.checklistName}}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-4" [ngClass]="{displayNone:hideEnvDD}">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding ">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      (click)="envMapListGenerate()" [ngClass]="{ dis:fieldsDisabled}" type="button"
                      data-toggle="dropdown">
                      <div class="row strict">
                        <div class="col-xs-10 span-on-button ">
                          {{singleEnvironmentName||'taskPlanner1.chooseEnvironmentButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu fit-size">
                      <li *ngIf="!listOfEnv.length && !envMapArrayList.length">
                        <div class="alert alert-warning mb-0 pb-1 pt-1">
                          <strong>{{'taskPlanner.noEnvDefined' | translate}}</strong>
                        </div>
                      </li>
                      <div class="row">
                        <div class="col-xs-12">
                          <div class="input-group input-group-sm">
                            <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                              [placeholder]="'taskPlanner.findinenvironments'| translate">
                            <span class="input-group-addon " id="basic-addon2">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faSearch"></fa-icon>
                            </span>
                            <span class="input-group-addon" id="basic-addon3" data-toggle="modal"
                              data-target="#addNewEnvPopup">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                            </span>
                          </div>
                        </div>
                      </div>
                      <li (click)="changeEnvironment(env.name)"
                        *ngFor="let env of envMapArrayList|taskPlannerEnvironmentFilterWithSearchText:filterTypeList:searchText; let tabIndex = index">
                        <a class="dropdown-item" title={{env.value}}>{{env.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- Attribute and environment dropdown close -->
            <div class="col-xs-2" [ngClass]="{displayNone:hideEUTDD}">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding ">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      [ngClass]="{ dis:fieldsDisabled || attrDisabled||!entityName}" type="button"
                      data-toggle="dropdown">
                      <div class="row strict" *ngIf="attributeSelected.length">
                        <div class="col-xs-8 col-sm-8 col-md-10 col-lg-10 col-xl-10 span-on-button">
                          {{'taskPlanner1.chooseAttributeButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                      <div class="row strict" *ngIf="!attributeSelected.length">
                        <div class="col-xs-8 col-sm-8 col-md-10 col-lg-10 col-xl-10 span-on-button ">
                          {{'taskPlanner1.chooseAttributeButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu fit-size w-200">

                      <!-- for EUTType TF -->
                      <li class="row strict"
                        *ngFor="let attr of testTypes|landscaperEntity:{eType:selectedEUT}:filterTypeList; let tabIndex = index">
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                          <div style="text-align: center;">
                            <input class="marginleft3px" (click)="mapEutToAtt(attr,$event.target.checked)"
                              [checked]="isCheckedAtt(attr)" type="checkbox">
                          </div>
                        </div>
                        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item pl-2">
                          {{attr.name}}
                        </div>
                      </li>
                      <li class="row strict" *ngFor="let attr of appConstlistOfAttributes; let tabIndex = index">
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                          <div style="text-align: center;">
                            <input class="marginleft3px" (click)="mapEutToAtt(attr,$event.target.checked)"
                              [checked]="isCheckedAtt(attr)" type="checkbox">
                          </div>
                        </div>
                        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item pl-2">
                          {{attr.name}}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-2" [ngClass]="{displayNone:hideEUTDD}">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding ">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      (click)="envMapListGenerate()" [ngClass]="{ dis:fieldsDisabled}" type="button"
                      data-toggle="dropdown">
                      <div class="row strict">
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-10 col-xl-10 span-on-button">
                          {{singleEnvironmentName||'taskPlanner1.chooseEnvironmentButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu fit-size w-200">
                      <li *ngIf="!listOfEnv.length && !envMapArrayList.length">
                        <div class="alert alert-warning mb-0 pb-1 pt-1">
                          <strong>{{'taskPlanner.noEnvDefined' | translate}}</strong>
                        </div>
                      </li>
                      <div class="row">
                        <div class="col-xs-12">
                          <div class="input-group input-group-sm">
                            <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                              [placeholder]="'taskPlanner.findinenvironments'| translate">
                            <span class="input-group-addon " id="basic-addon2">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faSearch"></fa-icon>
                            </span>
                            <span class="input-group-addon" id="basic-addon3" data-toggle="modal"
                              data-target="#addNewEnvPopup">
                              <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                            </span>
                          </div>
                        </div>
                      </div>
                      <li (click)="changeEnvironment(env.name)"
                        *ngFor="let env of envMapArrayList|taskPlannerEnvironmentFilterWithSearchText:filterTypeList:searchText; let tabIndex = index">
                        <a class="dropdown-item" title={{env.value}}>{{env.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-2">
              <div class="row strict">
                <div class="col-sm-12 col-xs-12 btn-padding ">
                  <div class="dropdown">
                    <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                      [ngClass]="{ dis:!projectUserList.length || fieldsDisabled}" type="button" data-toggle="dropdown">
                      <div class="row strict">
                        <div class="col-xs-10 span-on-button ">
                          {{personName||'taskPlanner1.choosePersonButton' | translate }}
                        </div>
                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                          <span class="caret"></span>
                        </div>
                      </div>
                      <div class="row strict" *ngIf="!projectUserList.length">
                        <div class="col-xs-11 span-on-button text-flow ">
                          <div>{{'taskPlanner.noPersonaAvailable' | translate}}</div>
                        </div>
                        <div class="col-xs-1 pull-right ">
                          &nbsp;
                        </div>
                      </div>
                    </button>
                    <ul class="dropdown-menu fit-size w-150">
                      <li *ngIf="!projectUserList.length">
                        <div class="alert alert-warning mb-0 pb-1 pt-1">
                          <strong>{{'taskPlanner1.noPersonaAvailable' | translate}}</strong>
                        </div>
                      </li>
                      <li *ngFor="let person of model.projectUserList; let tabIndex = index"
                        (click)="loadPersonDetails(person)">
                        <a class="dropdown-item ">{{person.firstname}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-1 padding8px">
              <div class="row strict">
                <div class="col-xs-offset-1  col-xs-5">
                  <span class="mapperReadOnly" *ngIf="taskSelectedForModify == false">
                    <fa-icon id="addTaskButton" (click)="addTaskToPlanner()" [ngClass]="{ dis:taskSelectedForModify}"
                      class="fas menuItemsClrWhite bg-color-black" [icon]="faPlus"></fa-icon>
                  </span>
                  <span class="mapperReadOnly" *ngIf="taskSelectedForModify == true">
                    <fa-icon [ngClass]="{ dis:fieldsDisabled}" (click)="addTaskToPlanner()" class="fas" [icon]="faSave">
                    </fa-icon>

                  </span>
                </div>
                <div class="col-xs-offset-1  col-xs-5">
                  <span>
                    <fa-icon id="resetDataButton" class="fas menuItemsClrWhite bg-color-black" (click)="resetTaskData()"
                      [icon]="faRedo">
                    </fa-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 task-planner-tasks-table-height table-bordered border-none card p-1 mb-2 bg-white">
          <table id="taskPlannerListTable"
            class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable">
            <thead>
              <tr class="row strict">
                <th class="col-xs-10 border-right1px">
                  <div class="row strict">
                    <div class="col col-10 col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                      {{'taskPlanner1.TaskDesc' | translate}}
                    </div>
                    <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                    <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                    </div>
                  </div>
                </th>
                <th class="col-xs-1 border-right1px">
                  <div class="row strict">
                    <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      {{'taskPlanner1.actions' | translate}}
                    </div>
                  </div>
                </th>
                <th class="col-xs-1">
                  <div class="row strict">
                    <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      {{'taskPlanner1.status' | translate}}
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="task-planner-tasks-table-body-height">
              <tr class="clickable-row border-bottom1px" [ngClass]="{displayNone:task.entity_Id ==''}"
                *ngFor="let task of mySprintPlannerList; let tabIndex = index" class="cursorPointer bg-color-black">
                <td class="col-xs-10 border-right1px border-left1px"
                  [ngClass]="{ dis:task.partialExecute==true ||task.completed==true}"
                  (click)="selectedTaskToEdit(task)">
                  {{task.description}}
                </td>
                <td class="col-xs-1 border-right1px ">
                  <div class="row strict">
                    <div class="col-xs-offset-1 col-xs-3 mapperReadOnly">
                      <fa-icon id="taskEntityLinkButton" class="fas" data-toggle="modal"
                        data-target="#taskImpactEntitiesModel" (click)="taskImpactedEntities(task)"
                        *ngIf="task.activity.type == 'TN' || task.activity.type == 'RM'" [icon]="faLink"></fa-icon>
                    </div>
                    <div class="col-xs-offset-1 col-xs-3 mapperReadOnly">
                      <fa-icon id="delTaskButton" class="fas" data-toggle="modal"
                        data-target="#projecttaskDeleteConfirmModel"
                        [ngClass]="{ dis:task.partialExecute==true ||task.completed==true}"
                        (click)="taskToBeDelete(task)" [icon]="faTrashAlt"></fa-icon>
                    </div>
                  </div>
                </td>
                <td class="col-xs-1 border-right1px ">
                  <div class="row strict">
                    <div class="col-xs-offset-1 col-xs-3">
                      <fa-icon class="fas" *ngIf="task.partialExecute == false && task.completed == true"
                        [icon]="faCheckCircle"></fa-icon>
                      <fa-icon
                        *ngIf="(task.status == '0' || task.status == '1' || task.status == '2') && task.completed == false && task.partialExecute == false"
                        class="far" [icon]="faCircle"></fa-icon>
                      <div class="halfCircleWrapper" *ngIf="task.partialExecute == true">
                        <div class="halfCircleOne"></div>
                        <div class="halfCircleTwo"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="taskplannerTip1" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'taskPlanner1.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'taskPlanner1.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'taskPlanner1.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- The task delete confirm message modal -->
  <div class="modal fade" id="projecttaskDeleteConfirmModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{'taskPlanner1.deletetask' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              (click)="deleteTaskFromPlannerList(delTaskDetails, false)" data-dismiss="modal">
              {{'yes' | translate}}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{'no' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The selection of sprint entities modal -->
  <div class="modal fade" id="sprintEntitiesModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body retest-impact-modal-body-height pb-0">
            <div class="row pl-0 pr-0 h-100">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 retest-impact-modal-body-content-height">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    Choose entites/user stories for {{sprintName}}
                  </label>
                </div>
                <ul class="nav nav-tabs planner-nav-tabs impactedEntityTabs">
                  <li class="nav-item" (click)="showSprintEntityList = 'platform'">
                    <a class="textClrBlack" [ngClass]="{ active:showSprintEntityList == 'platform'}">
                      Existing entities
                    </a>
                  </li>
                  <li class="nav-item" (click)="showSprintEntityList = 'jira'">
                    <a class="textClrBlack" [ngClass]="{ active:showSprintEntityList == 'jira'}">
                      Import from Jira
                    </a>
                  </li>
                  <li class="nav-item" (click)="showSprintEntityList = 'addEUT'">
                    <a class="textClrBlack" [ngClass]="{ active:showSprintEntityList == 'addEUT'}">
                      Add Entities
                    </a>
                  </li>
                </ul>
                <!-- section to select platform entites based on entity type -->
                <div *ngIf="showSprintEntityList == 'platform'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">

                  <!-- section for searching entity and adding a new entity -->
                  <div class="row strict">
                    <div class="col-xs-12">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control search-add-on" [(ngModel)]="eutsearchText"
                          [placeholder]="'entities.searchEntity'| translate">
                        <span class="input-group-addon " id="basic-addon2">
                          <fa-icon class="fa menuItemsClrBlack" [icon]="faSearch"></fa-icon>
                        </span>
                        <!-- <span class="input-group-addon" id="basic-addon3" data-toggle="modal"
                        data-target="#addNewEntityPopup">
                        <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                      </span> -->
                      </div>
                    </div>
                  </div>

                  <!-- ul nav list for selection entity type -->
                  <div class="row strict">
                    <ul class="nav nav-tabs planner-nav-tabs impactedEntityTabs">
                      <li class="nav-item" (click)="changeSprintEntity('TF')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUT == 'TF'}">
                          Features
                        </a>
                      </li>
                      <li class="nav-item" (click)="changeSprintEntity('UR')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUT == 'UR'}">
                          Requirements
                        </a>
                      </li>
                      <li class="nav-item" (click)="changeSprintEntity('BF')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUT == 'BF'}">
                          Flows
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- ul listing entities based on selected entity type -->
                  <ul class="list-inline">
                    <li class="row strict list-inline-item border-bottom1px w-98"
                      *ngIf="!entityExists(eutTypes[index])">
                      <div class="col-xs-12">
                        <div class="col-xs-12 alert alert-warning text-flow mb-0 pb-2 pt-2">
                          <strong>
                            {{ 'no' | translate }} {{getEntityType(eutTypes[index]) | lowercase}}
                            {{'taskPlanner.defined' | translate}}.
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li class="list-inline-item border-bottom1px w-98"
                      *ngFor="let eut of listOfEUTs|taskPlannerEUTFilterWithSearchText:{eType:selectedSprintEUT}:filterTypeList:eutsearchText; let tabIndex = index">
                      <label class="exportLable custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [checked]="isChecked(eut)"
                          (click)="selectSprintEUTs(eut,$event.target.checked)">
                        <span class="custom-control-indicator"></span>
                        <span class="marginleft10px">
                          ({{eut.eType}}) - {{eut.eName}}
                        </span>
                      </label>
                    </li>

                    <!-- <li class="row strict" *ngIf="!(model.mappedEntities.length > 0)">
                    <div class="col-xs-12">
                      <div class="col-xs-12 alert alert-warning text-flow mb-0 pb-2 pt-2">
                        <strong>{{ 'taskPlanner1.noMappedEntities' | translate }}</strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-inline-item border-bottom1px w-98"
                    *ngFor="let eut of model.mappedEntities; let tabIndex = index">
                    <label class="exportLable custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" [checked]="isChecked(eut)"
                        (click)="selectImpactEUT(eut,$event.target.checked)">
                      <span class="custom-control-indicator"></span>
                      <span class="marginleft10px">({{eut.eType}}) -
                        {{eut.eName}}</span>
                    </label>
                  </li>
                  <hr class="border-bottom1px mt-1 mb-1">
                  <li class="list-inline-item border-bottom1px w-98"
                    *ngFor="let eut of model.unmappedEntities; let tabIndex = index">
                    <label class="exportLable custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" [checked]="isChecked(eut)"
                        (click)="selectImpactEUT(eut,$event.target.checked)">
                      <span class="custom-control-indicator"></span>
                      <span class="marginleft10px">({{eut.eType}}) -
                        {{eut.eName}}</span>
                    </label>
                  </li> -->
                  </ul>
                </div>
                <div *ngIf="showSprintEntityList == 'jira'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">
                  <ul class="list-inline">
                    <li class="list-inline-item border-bottom1px w-98"
                      *ngFor="let eut of jiraProjectData; let jiraIndex = index">
                      <div class="row strict">
                        <div class="col col-11 col-sm-10 col-md-11 col-xs-10 col-xl-11 col-lg-11">
                          <label class="exportLable custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                              (click)="selectJiraSprintEUTs(eut,$event.target.checked)"
                              [checked]="checkJiraExists(eut.fields)">
                            <span class="custom-control-indicator"></span>
                            <span class="marginleft10px">
                              {{eut.fields.summary}}
                            </span>
                          </label>
                          <!-- [checked]="isChecked(eut)" -->
                        </div>
                        <div class="col col-1 col-sm-2 col-md-1 col-xs-2 col-xl-1 col-lg-1">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                              type="button" data-toggle="dropdown" [ngClass]="{ dis:checkJiraExists(eut.fields)}">
                              <div class="row strict">
                                <div class="col-xs-10">
                                  <span *ngIf="checkJiraExists(eut.fields) == true">
                                    {{getJiraEUTType(eut.fields)}}
                                  </span>
                                  <span *ngIf="checkJiraExists(eut.fields) == false">
                                    {{eut.fields.eType}}
                                  </span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu">
                              <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                                <div class="col-xs-11 col-xs-offset-1 dropdown-item"
                                  (click)="updateJiraEUTType(eut,jiraIndex)">
                                  {{eut}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div *ngIf="showSprintEntityList == 'addEUT'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">
                  <!-- Modal body -->
                  <div class="sprint-planner-add-new-entites-modal-body-height">
                    <div class="row pb-0">
                      <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div class="form-element text-align-center">
                          <div class="row padding2px" *ngFor="let eut of entityMultipleAdd; let eutindex = index">
                            <div class="col col-9 col-xs-9 col-md-9 col-xl-9 col-lg-9">
                              <input type="text" class="form-control search-add-on taskplanner-inputfield"
                                [(ngModel)]="eut.entityDesc"
                                [placeholder]="eut.type == 'TF' ? 'Add Feature' :eut.type == 'UR' ? 'Add Requirement' :eut.type == 'BF' ? 'Add Flow' : 'Add Entity'| translate">
                            </div>
                            <div class="col col-2 col-xs-2 col-md-2 col-xl-2 col-lg-2">
                              <div class="dropdown">
                                <button
                                  class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                                  type="button" data-toggle="dropdown">
                                  <div class="row strict">
                                    <div class="col-xs-10">
                                      <span>{{eut.type}}
                                      </span>
                                    </div>
                                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                      <span class="caret"></span>
                                    </div>
                                  </div>
                                </button>
                                <ul class="dropdown-menu testDesignerEntityDropdown">
                                  <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                                    <div class="col-xs-11 col-xs-offset-1   dropdown-item"
                                      (click)="updateEUTType(eut,eutindex)">
                                      {{eut}}
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="col col-1 col-xs-1 col-md-1 col-xl-1 col-lg-1">
                              <button type="button" *ngIf="entityMultipleAdd.length > 1"
                                (click)="deleteRow(eutindex)">&times;</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Modal footer  -->
                  <div class="modal-footer text-align-center">
                    <button type="button" class="btn btn-secondary modalActionBtn" (click)="addRow()">
                      {{ 'add' | translate }} more
                    </button>
                    <!-- <button type="button" class="btn btn-secondary modalActionBtn" (click)="addMultipleEuts()">
                    {{ 'save' | translate }}
                  </button> -->
                  </div>

                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
                (click)="updateSprintEUTs()">
                {{'done' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The selection of impacted entities modal -->
  <div class="modal fade" id="taskImpactEntitiesModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body retest-impact-modal-body-height pb-0">
            <div class="row pl-0 pr-0 h-100">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 retest-impact-modal-body-content-height">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    Choose impacted entites/user stories for {{impactedEntitySelected.entity_desc}}
                  </label>
                </div>
                <ul class="nav nav-tabs planner-nav-tabs impactedEntityTabs">
                  <li class="nav-item" (click)="showImpactedEntityList = 'platform'">
                    <a class="textClrBlack" [ngClass]="{ active:showImpactedEntityList == 'platform'}">
                      Existing entities
                    </a>
                  </li>
                  <li class="nav-item" (click)="showImpactedEntityList = 'jira'">
                    <a class="textClrBlack" [ngClass]="{ active:showImpactedEntityList == 'jira'}">
                      Import from Jira
                    </a>
                  </li>
                  <li class="nav-item" (click)="showImpactedEntityList = 'addEUT'">
                    <a class="textClrBlack" [ngClass]="{ active:showImpactedEntityList == 'addEUT'}">
                      Add Entities
                    </a>
                  </li>
                </ul>
                <!-- section to select platform entites based on entity type -->
                <div *ngIf="showImpactedEntityList == 'platform'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">

                  <!-- section for searching entity and adding a new entity -->
                  <div class="row strict">
                    <div class="col-xs-12">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control search-add-on" [(ngModel)]="eutsearchText"
                          [placeholder]="'entities.searchEntity'| translate">
                        <span class="input-group-addon " id="basic-addon2">
                          <fa-icon class="fa menuItemsClrBlack" [icon]="faSearch"></fa-icon>
                        </span>
                        <!-- <span class="input-group-addon" id="basic-addon3" data-toggle="modal"
                          data-target="#addNewEntityPopup">
                          <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                        </span> -->
                      </div>
                    </div>
                  </div>

                  <!-- ul nav list for selection entity type -->
                  <div class="row strict">
                    <ul class="nav nav-tabs planner-nav-tabs impactedEntityTabs">
                      <li class="nav-item" (click)="changeSprintEntityImpact('TF')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUTImpact == 'TF'}">
                          Features
                        </a>
                      </li>
                      <li class="nav-item" (click)="changeSprintEntityImpact('UR')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUTImpact == 'UR'}">
                          Requirements
                        </a>
                      </li>
                      <li class="nav-item" (click)="changeSprintEntityImpact('BF')">
                        <a class="textClrBlack" [ngClass]="{ active:selectedSprintEUTImpact == 'BF'}">
                          Flows
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- ul listing entities based on selected entity type -->
                  <ul class="list-inline">
                    <li class="row strict list-inline-item border-bottom1px w-98"
                      *ngIf="!entityExists(eutTypes[index])">
                      <div class="col-xs-12">
                        <div class="col-xs-12 alert alert-warning text-flow mb-0 pb-2 pt-2">
                          <strong>
                            {{ 'no' | translate }} {{getEntityType(eutTypes[index]) | lowercase}}
                            {{'taskPlanner.defined' | translate}}.
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li class="list-inline-item border-bottom1px w-98"
                      [ngClass]="{ displayNone:impactedEntitySelected.entity_Id == eut.eID}"
                      *ngFor="let eut of listOfEUTs|taskPlannerEUTFilterWithSearchText:{eType:selectedSprintEUTImpact}:filterTypeList:eutsearchText; let tabIndex = index">
                      <label class="exportLable custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [checked]="checkImpactedEUT(eut)"
                          (click)="chooseImpactedEUTs(eut,$event.target.checked)">
                        <span class="custom-control-indicator"></span>
                        <span class="marginleft10px">
                          ({{eut.eType}}) - {{eut.eName}}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div *ngIf="showImpactedEntityList == 'jira'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">
                  <ul class="list-inline">
                    <li class="list-inline-item border-bottom1px w-98"
                      *ngFor="let eut of jiraProjectData; let jiraIndex = index">
                      <div class="row strict">
                        <div class="col col-11 col-sm-10 col-md-11 col-xs-10 col-xl-11 col-lg-11">
                          <label class="exportLable custom-control custom-checkbox">
                            <input type="checkbox" (click)="selectJiraImpactEUTs(eut,$event.target.checked)"
                              [checked]="checkJiraImpactExists(eut.fields)" class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                            <span class="marginleft10px">
                              {{eut.fields.summary}}
                            </span>
                          </label>
                          <!-- [checked]="checkJiraExists(eut.fields)" -->
                        </div>
                        <div class="col col-1 col-sm-2 col-md-1 col-xs-2 col-xl-1 col-lg-1">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                              type="button" data-toggle="dropdown" [ngClass]="{ dis:checkJiraExists(eut.fields)}">
                              <div class="row strict">
                                <div class="col-xs-10">
                                  <span *ngIf="checkJiraExists(eut.fields) == true">
                                    {{getJiraEUTType(eut.fields)}}
                                  </span>
                                  <span *ngIf="checkJiraExists(eut.fields) == false">
                                    {{eut.fields.eType}}
                                  </span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu">
                              <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                                <div class="col-xs-11 col-xs-offset-1 dropdown-item"
                                  (click)="updateJiraEUTType(eut,jiraIndex)">
                                  {{eut}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div *ngIf="showImpactedEntityList == 'addEUT'"
                  class="table-bordered table-bordered-bottom overflowYTextAuto retest-impact-modal-body-table-content-height impactEntitiesModalTable">
                  <!-- Modal body -->
                  <div class="sprint-planner-add-new-entites-modal-body-height">
                    <div class="row pb-0">
                      <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div class="form-element text-align-center">
                          <div class="row padding2px"
                            *ngFor="let eut of impactedentityMultipleAdd; let eutindex = index">
                            <div class="col col-9 col-xs-9 col-md-9 col-xl-9 col-lg-9">
                              <input type="text" class="form-control search-add-on taskplanner-inputfield"
                                [(ngModel)]="eut.entityDesc"
                                [placeholder]="eut.type == 'TF' ? 'Add Feature' :eut.type == 'UR' ? 'Add Requirement' :eut.type == 'BF' ? 'Add Flow' : 'Add Entity'| translate">
                            </div>
                            <div class="col col-2 col-xs-2 col-md-2 col-xl-2 col-lg-2">
                              <div class="dropdown">
                                <button
                                  class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                                  type="button" data-toggle="dropdown">
                                  <div class="row strict">
                                    <div class="col-xs-10">
                                      <span>{{eut.type}}
                                      </span>
                                    </div>
                                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                      <span class="caret"></span>
                                    </div>
                                  </div>
                                </button>
                                <ul class="dropdown-menu testDesignerEntityDropdown">
                                  <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                                    <div class="col-xs-11 col-xs-offset-1   dropdown-item"
                                      (click)="impactedupdateEUTType(eut,eutindex)">
                                      {{eut}}
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="col col-1 col-xs-1 col-md-1 col-xl-1 col-lg-1">
                              <button type="button" *ngIf="impactedentityMultipleAdd.length > 1"
                                (click)="impacteddeleteRow(eutindex)">&times;</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Modal footer  -->
                  <div class="modal-footer text-align-center">
                    <button type="button" class="btn btn-secondary modalActionBtn" (click)="impactedaddRow()">
                      {{ 'add' | translate }} more
                    </button>
                    <!-- <button type="button" class="btn btn-secondary modalActionBtn" (click)="addMultipleEuts()">
                      {{ 'save' | translate }}
                    </button> -->
                  </div>

                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" (click)="updateImpactedSprintEUTs()"
                data-dismiss="modal">
                {{'done' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The plan delete confirm message modal -->
  <div class="modal fade" id="newSPsprintDeleteConfirmModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{'taskPlanner.deleteplan' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              (click)="deletePlan(selectedSprintDetails)" data-dismiss="modal">
              {{'yes' | translate}}
            </button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{'no' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The plane name selection modal to generate exucutor report -->
  <div class="modal fade" id="taskPlannerPlanSelectionPopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
                <div class="form-element mt-0 dropdown">
                  <label class="form-label displayNone">{{ 'taskPlanner1.choosePlanName' | translate }}</label>
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    [ngClass]="{ dis:sprintNamesArray.length<=0}" type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-10 span-on-button ">
                        <span *ngIf="sprintNamesArray.length > 0">
                          {{modalPlannerName || 'taskPlanner1.choosePlanHeading' | translate }}
                        </span>
                        <span *ngIf="sprintNamesArray.length <= 0">
                          {{modalPlannerName || 'taskPlanner.addPlanHeading' | translate }}
                        </span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu planNameSelectionDropdown">
                    <li (click)="selectedPlannameToLS(task.plan_name)"
                      [ngClass]="{displayNone:sprintNamesArray.length<=0}"
                      *ngFor="let task of sprintNamesArray; let tabIndex = index">
                      <a>{{task.plan_name}}</a>
                    </li>
                    <li *ngIf="!(sprintNamesArray.length > 0)" [ngClass]="{ dis:sprintNamesArray.length <= 0}">
                      <div class="col-xs-12 alert mb-0 p-0">
                        <strong>{{ 'taskPlanner.emptyPlannameList' | translate }}</strong>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
                <div class="form-element">
                  <label class="form-label displayNone">&nbsp;</label>
                  <div class="form-element-input ml-2">
                    <button type="button" data-dismiss="modal"
                      class="btn btn-sm btn-secondary userInvitetoOrgBtn actionbutton mt-0 mb-0 paddingtop4px paddingbottom4px"
                      [ngClass]="{ dis:modalPlannerName==''}" (click)="generateReport('true')">
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTP1" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTP1" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.taskplanner' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" id="Tp1VideoLink" class="youtubeVideo" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The empty data popup modal -->
  <div class="modal fade" id="taskPlannerMsgPopup1" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    {{toastMsgPopup}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- The new entity add popup modal -->
  <div class="modal fade" id="addNewEntityPopup" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body sprint-planner-add-new-entites-modal-body-height">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <div class="row padding2px" *ngFor="let eut of entityMultipleAdd; let eutindex = index">
                    <div class="col col-9 col-xs-9 col-md-9 col-xl-9 col-lg-9">
                      <input type="text" class="form-control search-add-on taskplanner-inputfield"
                        [(ngModel)]="eut.entityDesc"
                        [placeholder]="eut.type == 'TF' ? 'Add Feature' :eut.type == 'UR' ? 'Add Requirement' :eut.type == 'BF' ? 'Add Flow' : 'Add Entity'| translate">
                    </div>
                    <div class="col col-2 col-xs-2 col-md-2 col-xl-2 col-lg-2">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-10">
                              <span>{{eut.type}}
                              </span>
                            </div>
                            <div class="col-xs-1 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu testDesignerEntityDropdown">
                          <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                            <div class="col-xs-11 col-xs-offset-1   dropdown-item"
                              (click)="updateEUTType(eut,eutindex)">
                              {{eut}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col col-1 col-xs-1 col-md-1 col-xl-1 col-lg-1">
                      <button type="button" (click)="deleteRow(eutindex)">&times;</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer  -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" (click)="addRow()">
              {{ 'add' | translate }} row
            </button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="addMultipleEuts()">
              {{ 'save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The new entity add popup modal -->
  <div class="modal fade" id="addNewEnvPopup" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <div class="row">
                    <div class="col col-12 col-xs-12 col-md-12 col-xl-12 col-lg-12">
                      <input type="text" class="form-control search-add-on taskplanner-inputfield"
                        [(ngModel)]="addEnvModel" [placeholder]="'Add Environment'| translate">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" (click)="addEnv()" data-dismiss="modal">
              {{ 'add' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>